import { FeatherEye } from "@subframe/core";

import { QuestionAnswerInput } from "@/lib/checklist-utils";

interface Question {
  id: string;
  questionText: string;
  questionType?: string;
  orderIndex?: number;
  isHidden?: boolean;
  allowPhoto?: boolean;
  allowNotes?: boolean;
  options?: {
    choices?: string[];
  };
}

interface QuestionsTabProps {
  questions: Question[];
}

export function QuestionsTab({ questions }: QuestionsTabProps) {
  if (!questions || questions.length === 0) {
    return (
      <div className="flex w-full items-center justify-center px-6 pt-8 pb-6">
        <div className="flex w-256 max-w-full flex-none flex-col items-center rounded-lg bg-default-background px-8 py-12">
          <span className="text-body font-body text-subtext-color">
            No questions in this template
          </span>
        </div>
      </div>
    );
  }

  const sortedQuestions = [...questions]
    .filter((q) => !q.isHidden)
    .sort((a, b) => (a.orderIndex || 0) - (b.orderIndex || 0));

  return (
    <div className="flex w-full items-center justify-center px-6 pt-8 pb-6">
      <div className="flex w-256 max-w-full flex-none flex-col items-start rounded-lg bg-default-background mb-8">
        <div className="flex w-full flex-col items-start gap-8 px-8 py-8">
          {/* Preview banner */}
          <div className="flex w-full items-center gap-2 rounded-sm bg-neutral-100 px-4 py-3">
            <FeatherEye className="text-heading-3 font-heading-3 text-neutral-600" />
            <span className="text-heading-3 font-heading-2 text-neutral-600">
              Preview — this is how staff will see the checklist
            </span>
          </div>

          {/* Section header */}
          <div className="flex w-full flex-col items-start">
            <span className="text-heading-2 font-heading-2 text-default-font">
              Questions
            </span>
          </div>

          {/* Questions list — mirrors practitioner execution view */}
          {sortedQuestions.map((question, index) => (
            <div key={question.id} className="w-full">
              <div className="flex w-full flex-col items-start gap-4">
                {/* Question header with number */}
                <div className="flex w-full items-start gap-3">
                  <div className="flex items-center gap-2 pt-1">
                    <div className="flex h-8 w-8 flex-none flex-col items-center justify-center gap-2 overflow-hidden rounded-full bg-neutral-100 relative">
                      <span className="line-clamp-1 w-full font-['Manrope'] text-[14px] font-[600] leading-[14px] text-neutral-800 text-center absolute">
                        {index + 1}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 pt-2">
                    <span className="text-heading-3 font-heading-3 text-neutral-900">
                      {question.questionText}
                    </span>
                  </div>
                </div>

                {/* Answer input — read-only */}
                <div className="flex w-full flex-col items-start gap-3">
                  <QuestionAnswerInput questionType={question.questionType} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
